import * as React from 'react';

function SvgDollarSignInCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={40} height={40} fill="none" viewBox="0 0 40 40" {...props}>
      <rect width={40} height={40} fill="#F0F0F0" rx={20} />
      <path
        fill="#000"
        d="M19.8 18.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.42 0 2.13.54 2.39 1.4.12.4.45.7.87.7h.3c.66 0 1.13-.65.9-1.27-.42-1.18-1.4-2.16-2.96-2.54v-.69c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.66c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-1.65 0-2.5-.59-2.83-1.43-.15-.39-.49-.67-.9-.67h-.28c-.67 0-1.14.68-.89 1.3.57 1.39 1.9 2.21 3.4 2.53v.67c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.65c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
      />
    </svg>
  );
}

export default SvgDollarSignInCircle;
